var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpdesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_359_45708)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447.8 437.4H51.8997C46.2997 437.4 41.6997 432.8 41.6997 427.2V30.2001C41.6997 25.2001 45.7997 21.1001 50.7997 21.1001H446.8C453 21.1001 458 26.1001 458 32.3001V427.2C458 432.8 453.5 437.4 447.8 437.4Z",
    className: "illustration_primary-lightest"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M432.3 46.6001H67.3999V404.5H432.3V46.6001Z",
    className: "illustration_secondary"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M495.2 478.8H4.7998C2.0998 478.8 -0.200195 476.6 -0.200195 473.8V462.3H499.8V474.1C499.9 476.7 497.8 478.8 495.2 478.8Z",
    fill: "#FFE600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M499.9 462.3L432.3 409.4V295.6H67.3999V409.4L-0.100098 462.3H499.9Z",
    className: "illustration_tertiary"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.3 437.4C282.916 437.4 312.6 426.476 312.6 413C312.6 399.524 282.916 388.6 246.3 388.6C209.684 388.6 180 399.524 180 413C180 426.476 209.684 437.4 246.3 437.4Z",
    fill: "#FFE600"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_359_45708",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 46,
    width: 366,
    height: 359
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M432.3 46.6001H67.3999V404.5H432.3V46.6001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_359_45708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489 39.8999H349.6V293.6H489V39.8999Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.2 100.2H360.6V110.7H505.2V100.2Z",
    className: "illustration_secondary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.2 165.4H360.6V175.9H505.2V165.4Z",
    className: "illustration_secondary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.099 127.8H425.399V164.9H434.099V127.8Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.6 137H428V160.1H431.6V137Z",
    className: "illustration_primary-lightest"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413 137.6H398V164.9H413V137.6Z",
    fill: "#8E64C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.399 132.1H412.899V165.1H420.399V132.1Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.399 159.2H412.899V161.5H420.399V159.2Z",
    className: "illustration_primary-lightest"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M425.399 126.6H420.399V165.1H425.399V126.6Z",
    fill: "#009569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.1 129.9H364.7V165.1H374.1V129.9Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.5 163H367.3V134.9H371.5",
    className: "illustration_primary-lightest"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.5 133.8H374.1V165H384.5V133.8Z",
    fill: "#8E64C3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.7 163.2H377V138.3H381.7",
    className: "illustration_primary-lightest"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M397.9 140.5H384.5V165.1H397.9V140.5Z",
    fill: "#2B7F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.06 100.05L416.76 100.05L416.76 62.9503L408.06 62.9503L408.06 100.05Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.422 100.05L408.122 100.05L408.122 62.9503L399.422 62.9503L399.422 100.05Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.5 100.105L399.4 100.105L399.4 72.8055L390.5 72.8055L390.5 100.105Z",
    fill: "#8E64C3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.921 95.2563L405.521 95.2563L405.521 72.1563L401.921 72.1563L401.921 95.2563Z",
    className: "illustration_primary-lightest"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M429.199 100.105L444.199 100.105L444.199 72.8055L429.199 72.8055L429.199 100.105Z",
    fill: "#8E64C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.75 100.256L429.25 100.256L429.25 67.2563L421.75 67.2563L421.75 100.256Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.75 96.667L429.25 96.667L429.25 94.367L421.75 94.367L421.75 96.667Z",
    className: "illustration_primary-lightest"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.749 100.191L421.749 100.191L421.749 61.6909L416.749 61.6909L416.749 100.191Z",
    fill: "#009569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.95 97.3706L382.987 99.9575L392.674 66.1162L383.637 63.5294L373.95 97.3706Z",
    fill: "#009569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.947 99.3138L373.159 99.9468L382.846 66.1055L380.634 65.4725L370.947 99.3138Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.682 98.1293L370.835 99.8906L380.522 66.0493L374.37 64.2881L364.682 98.1293Z",
    fill: "#2B7F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4691 293.714L150.869 293.714L150.869 40.0143L11.4691 40.0143L11.4691 293.714Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.73036 110.716L139.87 110.716L139.87 100.216L-4.73036 100.216L-4.73036 110.716Z",
    className: "illustration_secondary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.73036 175.816L139.87 175.816L139.87 165.316L-4.73036 165.316L-4.73036 175.816Z",
    className: "illustration_secondary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2883 164.891L74.9883 164.891L74.9883 127.791L66.2883 127.791L66.2883 164.891Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8883 160.097L72.4883 160.097L72.4883 136.997L68.8883 136.997L68.8883 160.097Z",
    className: "illustration_primary-lightest"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.5273 164.946L102.527 164.946L102.527 137.646L87.5273 137.646L87.5273 164.946Z",
    fill: "#8E64C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0786 164.997L87.5786 164.997L87.5786 131.997L80.0786 131.997L80.0786 164.997Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0786 161.507L87.5786 161.507L87.5786 159.207L80.0786 159.207L80.0786 161.507Z",
    className: "illustration_primary-lightest"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.0767 165.031L80.0767 165.031L80.0767 126.531L75.0767 126.531L75.0767 165.031Z",
    fill: "#009569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.373 165.017L135.773 165.017L135.773 129.817L126.373 129.817L126.373 165.017Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.925 165.041L126.325 165.041L126.325 133.841L115.925 133.841L115.925 165.041Z",
    fill: "#8E64C3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.8 163.2H123.4V138.3H118.8",
    className: "illustration_primary-lightest"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.508 165.002L115.908 165.002L115.908 140.402L102.508 140.402L102.508 165.002Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3997 63H83.6997V100.1H92.3997V63Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1 63H92.3999V100.1H101.1V63Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9 72.7998H101V100.1H109.9V72.7998Z",
    fill: "#8E64C3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.4999 72.1997H94.8999V95.2997H98.4999V72.1997Z",
    className: "illustration_primary-lightest"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.1997 72.7998H56.1997V100.1H71.1997V72.7998Z",
    fill: "#8E64C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6997 67.1997H71.1997V100.2H78.6997V67.1997Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.6997 94.3999H71.1997V96.6999H78.6997V94.3999Z",
    className: "illustration_primary-lightest"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.6997 61.7998H78.6997V100.3H83.6997V61.7998Z",
    fill: "#009569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.4 282.3H54.7998V304.9H445.4V282.3Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 267H212.3C205.9 267 200.7 261.8 200.7 255.4V157.3C200.7 150.9 205.9 145.7 212.3 145.7H276C282.4 145.7 287.6 150.9 287.6 157.3V255.4C287.5 261.8 282.3 267 276 267Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7 291.9H191.4C189.1 291.9 187.2 290 187.2 287.7V220.8C187.2 218.5 189.1 216.6 191.4 216.6H201.7C204 216.6 205.9 218.5 205.9 220.8V287.7C205.9 290 204 291.9 201.7 291.9Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.9 291.9H286.6C284.3 291.9 282.4 290 282.4 287.7V220.8C282.4 218.5 284.3 216.6 286.6 216.6H296.9C299.2 216.6 301.1 218.5 301.1 220.8V287.7C301.2 290 299.3 291.9 296.9 291.9Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.5 217.9C297.4 213 303 194.8 310 182.8C313 177.6 313.6 173.9 317.7 171.2C321.7 168.5 327.1 162 326.8 161.4C326.1 159.9 320.7 164.3 320.7 164.3C320.7 164.3 326.6 156.6 325.6 155.1C325 154.1 319 158.8 317.2 161.1C318.3 159.7 323.2 151.7 322.2 150.6C321 149.2 314.4 157.5 313.8 158.3C314.2 157.6 317.6 148.7 315.9 148.1C314 147.4 307.1 160.9 307.1 160.9C305.3 159.2 304.4 153.1 300.6 156.8C301.1 159.3 305.6 162.7 302.7 171.9C301.8 174.8 294.2 190.4 284.3 197.8C279 188.8 270.4 173.6 263.8 171.3C257.8 169.2 253 170.3 251.8 176.2C251.4 178.1 251.7 180.1 252.8 181.7C258.1 190.4 279.1 223 288.5 217.9Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.9 166.7C252.9 166.7 247.3 171.5 249.2 175.9C251.1 180.3 261.5 200.7 267.4 207.7C273.3 214.7 283.2 196 283.2 196C283.2 196 269.6 168.4 264.6 165.7C259.8 162.9 252.9 166.7 252.9 166.7Z",
    className: "illustration_tertiary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.6 224.4C194 221.2 185.1 204.3 176 193.8C172.1 189.2 170.9 185.7 166.3 183.8C161.8 181.9 155.4 176.5 155.6 175.8C156 174.2 162.1 177.6 162.1 177.6C162.1 177.6 154.9 171.1 155.6 169.4C156 168.3 162.7 171.8 165 173.7C163.6 172.5 157.4 165.5 158.2 164.3C159.2 162.7 167.2 169.7 167.9 170.3C167.3 169.7 162.4 161.6 164 160.6C165.7 159.6 175 171.6 175 171.6C176.5 169.6 176.2 163.5 180.6 166.4C180.6 169 176.8 173.1 181.3 181.6C182.7 184.3 193 198.2 204.1 203.7C207.7 193.8 213.3 177.4 219.4 173.9C225 170.7 229.8 170.9 232.1 176.5C232.8 178.3 232.9 180.3 232.2 182.1C228.4 191.9 213.7 227.8 203.6 224.4Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.2 167.6C229.2 167.6 235.6 171.3 234.5 176C233.4 180.7 227 202.6 222.4 210.6C217.8 218.5 204.7 202 204.7 202C204.7 202 213.1 172.4 217.4 168.8C221.7 165.2 229.2 167.6 229.2 167.6Z",
    className: "illustration_tertiary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.6 168C213.3 174 213.9 195 217.6 213.8C221.4 233 215.2 257.8 224.3 259.5C281.7 270.1 267 228.8 268.3 216.1C269.5 205.2 278.8 190.5 267 170.5C259.4 157.5 232.6 158.1 220.6 168Z",
    className: "illustration_tertiary"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.1 162.9C233 165.4 234 169.5 237.5 171.6C244 175.4 249.2 171.6 252 169.8C254.8 168 255.1 163.5 251.4 161.6C247.7 159.7 236.4 158 234.1 162.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.6 169.5H242C238.7 169.5 236.1 166.8 236.1 163.6V149.4C236.1 146.1 238.8 143.5 242 143.5H244.6C247.9 143.5 250.5 146.2 250.5 149.4V163.6C250.5 166.8 247.8 169.5 244.6 169.5Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.799 115.3C265.799 122.2 269.099 135.1 266.799 144.7C264.499 154.3 255.899 163.1 241.499 154.4C232.699 149.1 231.199 139.2 232.799 131.9C233.299 129.8 230.099 116.3 232.199 114.2C236.199 110.2 264.499 113.1 264.799 115.3Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.099 134.9C263.762 134.9 264.299 134.362 264.299 133.7C264.299 133.037 263.762 132.5 263.099 132.5C262.437 132.5 261.899 133.037 261.899 133.7C261.899 134.362 262.437 134.9 263.099 134.9Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.8 134.9C246.462 134.9 247 134.362 247 133.7C247 133.037 246.462 132.5 245.8 132.5C245.137 132.5 244.6 133.037 244.6 133.7C244.6 134.362 245.137 134.9 245.8 134.9Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.599 150.4C254.399 150.4 254.099 150.4 253.899 150.4C252.299 150.2 251.199 149.6 250.599 148.7C249.699 147.4 250.099 145.8 250.099 145.7C250.099 145.5 250.299 145.4 250.399 145.4C250.599 145.3 250.699 145.4 250.899 145.5C254.799 148.3 258.599 145.6 258.799 145.5C258.999 145.4 259.199 145.4 259.399 145.5C259.599 145.6 259.699 145.8 259.599 146C259.299 147.5 257.899 150.4 254.599 150.4ZM250.999 146.7C250.999 147.1 251.099 147.6 251.399 148.1C251.899 148.8 252.699 149.2 253.999 149.4C256.499 149.7 257.699 148.1 258.199 146.9C256.699 147.6 253.899 148.4 250.999 146.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.599 142.5C255.099 142.5 254.699 142.4 254.699 142.4C254.399 142.3 254.299 142.1 254.299 141.8C254.399 141.5 254.599 141.4 254.899 141.4C255.299 141.5 256.199 141.6 256.499 141.2C256.599 141.1 256.699 140.8 256.599 140.5C256.199 138.6 254.599 136.5 254.599 136.5C254.399 136.3 254.499 136 254.699 135.8C254.899 135.6 255.199 135.7 255.399 135.9C255.499 136 257.199 138.2 257.599 140.3C257.799 141.2 257.499 141.7 257.199 141.9C256.799 142.4 256.199 142.5 255.599 142.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.2 134.7C227.2 134.7 222.7 124.2 231.1 114.7C239.5 105.2 247.5 105.8 256.9 108.3C266.7 111 269.5 124.1 269.5 124.1C269.5 124.1 246 123.9 241.6 122C240.5 130.6 235.6 134.3 227.2 134.7Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.599 141C234.599 141 231.399 142.1 229.599 141.5C226.999 140.6 226.299 136.8 227.399 134.5C228.499 132.2 233.099 132.4 234.499 133.6",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 116.7C241.522 116.7 246 112.223 246 106.7C246 101.177 241.522 96.6997 236 96.6997C230.477 96.6997 226 101.177 226 106.7C226 112.223 230.477 116.7 236 116.7Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.9 139.9C242.5 139.9 239.7 137.1 239.7 133.7C239.7 130.3 242.5 127.5 245.9 127.5C249.3 127.5 252.1 130.3 252.1 133.7C252.1 137.1 249.3 139.9 245.9 139.9ZM245.9 128.6C243 128.6 240.7 130.9 240.7 133.8C240.7 136.7 243 139 245.9 139C248.8 139 251.1 136.7 251.1 133.8C251.1 130.9 248.7 128.6 245.9 128.6Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.2 139.9C260.8 139.9 258 137.1 258 133.7C258 130.3 260.8 127.5 264.2 127.5C267.6 127.5 270.4 130.3 270.4 133.7C270.4 137.1 267.6 139.9 264.2 139.9ZM264.2 128.6C261.3 128.6 259 130.9 259 133.8C259 136.7 261.3 139 264.2 139C267.1 139 269.4 136.7 269.4 133.8C269.4 130.9 267 128.6 264.2 128.6Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.199 134.2H240.099L232.699 132.4C232.399 132.3 232.299 132.1 232.299 131.8C232.399 131.5 232.599 131.4 232.899 131.4L240.299 133.2C240.599 133.3 240.699 133.5 240.699 133.8C240.699 134.1 240.399 134.2 240.199 134.2Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.499 133.4C251.399 133.4 251.299 133.4 251.199 133.3C250.999 133.1 250.999 132.8 251.199 132.6C251.299 132.5 252.799 130.8 255.099 130.8C257.599 130.8 258.899 132.2 258.999 132.2C259.199 132.4 259.199 132.7 258.999 132.9C258.799 133.1 258.499 133.1 258.299 132.9C258.299 132.9 257.199 131.8 255.199 131.8C253.299 131.8 252.099 133.2 252.099 133.2C251.799 133.3 251.599 133.4 251.499 133.4Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.899 113.9H232.799C232.499 113.8 232.399 113.5 232.499 113.3C232.599 113.1 233.199 111.2 237.399 109.1C241.699 107 244.399 107.2 244.499 107.3C244.799 107.3 244.999 107.6 244.899 107.9C244.799 108.2 244.599 108.4 244.299 108.4C244.299 108.4 241.699 108.2 237.799 110.1C233.999 112 233.399 113.7 233.399 113.7C233.299 113.8 233.099 113.9 232.899 113.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.9 137.8C232.6 137.8 232.4 137.6 232.4 137.3C232.4 136.9 232.3 136.7 232.1 136.6C231.6 136.3 230.5 136.5 229.9 136.7C229.6 136.8 229.3 136.7 229.2 136.4C229.1 136.1 229.2 135.8 229.5 135.7C229.7 135.6 231.5 135 232.6 135.7C232.9 135.9 233.3 136.4 233.3 137.2C233.4 137.5 233.2 137.8 232.9 137.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.9 157.8C248.8 157.8 248.8 157.8 248.9 157.8C248.5 157.7 240.1 155.2 236.8 150.8C236.7 150.7 236.7 150.5 236.9 150.5C237 150.4 237.2 150.4 237.2 150.6C240.3 154.9 248.9 157.4 248.9 157.4C249 157.4 249.1 157.6 249.1 157.7C249.1 157.8 249 157.8 248.9 157.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.2 209.8C216.9 209.8 216.7 209.5 216.7 209.3L218 187.9C218 187.6 218.3 187.4 218.5 187.4C218.8 187.4 219 187.7 219 187.9L217.7 209.3C217.7 209.6 217.5 209.8 217.2 209.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.3 205.9C267 205.9 266.8 205.7 266.8 205.5L264.3 184.2C264.3 183.9 264.5 183.7 264.7 183.6C265 183.6 265.2 183.8 265.3 184L267.8 205.3C267.9 205.6 267.7 205.9 267.3 205.9C267.4 205.9 267.4 205.9 267.3 205.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.1 146.5C254.8 148.9 258.5 146.5 258.5 146.5C258.5 146.5 257.8 150 254 149.6C250.2 149.2 251.1 146.5 251.1 146.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.2 257.5V337.1C355.2 341.3 351.8 344.7 347.6 344.7H151.4C147.2 344.7 143.8 341.3 143.8 337.1V257.5H355.2Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.2 257.5H143.7V267H355.2V257.5Z",
    className: "illustration_primary"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.9 260.9H138.1C131.8 260.9 126.8 258.2 126.8 254.9L126.9 248.6C126.9 245.3 155.1 241.2 161.4 241.2L338 246.2C344.3 246.2 372.1 245.4 372.1 248.7L372.2 255C372.2 258.2 367.1 260.9 360.9 260.9Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.9 254.2H138.1C133.1 254.2 128.9 252.5 127.4 250.2C126.8 249.3 126.8 248.3 127.2 247.3L133.2 235.2C134.8 231.6 140.9 229.2 147.1 229.2H351.8C358.1 229.2 363.7 231 365.7 235.2L371.7 247.3C372.1 248.2 372.2 249.1 371.7 249.9C370.4 252.4 366 254.2 360.9 254.2Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.8 330.3C264.147 330.3 277.4 317.048 277.4 300.7C277.4 284.352 264.147 271.1 247.8 271.1C231.452 271.1 218.2 284.352 218.2 300.7C218.2 317.048 231.452 330.3 247.8 330.3Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.6 322.5C238.8 322.5 237 319.2 237 316C237 309.1 245.8 294.9 248.7 293.8C248.9 293.7 249.5 293.7 250.2 293.7C251.6 293.7 253.6 294 253.6 294.9C253.6 295 253.5 295.2 253.4 295.4C252.2 297.7 243.8 312.4 243.8 316.3C243.8 317.1 244.1 317.5 244.6 317.5C248.1 317.5 254.6 306.9 255.1 306.9C255.7 306.9 255.8 308.2 255.8 309C255.6 309.9 247.5 322.5 241.6 322.5ZM255.4 290.3C252.8 290.3 250.4 288.4 250.4 285.7C250.4 282.8 253 280.5 255.9 280.5C258.5 280.5 260.9 282.4 260.9 285.1C260.9 288.1 258.2 290.3 255.4 290.3Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.8 246.1H315.9C312.9 246.1 310.5 243.7 310.5 240.7V238.5C310.5 235.5 315.4 219.6 318.3 219.6H337.4C340.4 219.6 345.2 235.9 345.2 238.8V240.7C345.2 243.7 342.8 246.1 339.8 246.1Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.8 243.9H315.9C312.9 243.9 310.5 241.5 310.5 238.5L312.9 222.8C312.9 219.8 315.3 217.4 318.3 217.4H337.4C340.4 217.4 342.8 219.8 342.8 222.8L345.2 238.5C345.2 241.4 342.8 243.9 339.8 243.9Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.1 239.2C316.8 239.1 315 237.1 315.1 234.7L317.1 222.1C317.2 220.5 318.5 220.1 320.1 220.2C321.7 220.3 322.9 220.8 322.9 222.4L323.6 235.1C323.5 237.5 321.4 239.3 319.1 239.2Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.2 238C316.9 237.9 315.1 235.9 315.2 233.5L317.2 220.9C317.3 219.3 318.6 218.9 320.2 219C321.8 219.1 323 219.6 323 221.2L323.7 233.9C323.5 236.3 321.5 238.1 319.2 238Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.9 225.5H327.4C327.1 225.5 326.8 225.2 326.8 224.9L327.1 223.3C327.1 223 327.4 222.7 327.7 222.7H329.7C330 222.7 330.3 223 330.3 223.3L330.6 224.9C330.4 225.2 330.2 225.5 329.9 225.5Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 225.5H331.5C331.2 225.5 330.9 225.2 330.9 224.9L331.2 223.3C331.2 223 331.5 222.7 331.8 222.7H333.8C334.1 222.7 334.4 223 334.4 223.3L334.7 224.9C334.6 225.2 334.3 225.5 334 225.5Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.2 225.5H335.7C335.4 225.5 335.1 225.2 335.1 224.9L335.4 223.3C335.4 223 335.7 222.7 336 222.7H338C338.3 222.7 338.6 223 338.6 223.3L338.9 224.9C338.8 225.2 338.5 225.5 338.2 225.5Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.9 229.1H327.4C327.1 229.1 326.8 228.8 326.8 228.5L327.1 226.9C327.1 226.6 327.4 226.3 327.7 226.3H329.7C330 226.3 330.3 226.6 330.3 226.9L330.6 228.5C330.4 228.8 330.2 229.1 329.9 229.1Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 229.1H331.5C331.2 229.1 330.9 228.8 330.9 228.5L331.2 226.9C331.2 226.6 331.5 226.3 331.8 226.3H333.8C334.1 226.3 334.4 226.6 334.4 226.9L334.7 228.5C334.6 228.8 334.3 229.1 334 229.1Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.2 229.1H335.7C335.4 229.1 335.1 228.8 335.1 228.5L335.4 226.9C335.4 226.6 335.7 226.3 336 226.3H338C338.3 226.3 338.6 226.6 338.6 226.9L338.9 228.5C338.8 228.8 338.5 229.1 338.2 229.1Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.9 232.6H327.4C327.1 232.6 326.8 232.3 326.8 232L327.1 230.4C327.1 230.1 327.4 229.8 327.7 229.8H329.7C330 229.8 330.3 230.1 330.3 230.4L330.6 232C330.4 232.4 330.2 232.6 329.9 232.6Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 232.6H331.5C331.2 232.6 330.9 232.3 330.9 232L331.2 230.4C331.2 230.1 331.5 229.8 331.8 229.8H333.8C334.1 229.8 334.4 230.1 334.4 230.4L334.7 232C334.6 232.4 334.3 232.6 334 232.6Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.2 232.6H335.7C335.4 232.6 335.1 232.3 335.1 232L335.4 230.4C335.4 230.1 335.7 229.8 336 229.8H338C338.3 229.8 338.6 230.1 338.6 230.4L338.9 232C338.8 232.4 338.5 232.6 338.2 232.6Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.9 236.2H327.4C327.1 236.2 326.8 235.9 326.8 235.6L327.1 234C327.1 233.7 327.4 233.4 327.7 233.4H329.7C330 233.4 330.3 233.7 330.3 234L330.6 235.6C330.4 236 330.2 236.2 329.9 236.2Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 236.2H331.5C331.2 236.2 330.9 235.9 330.9 235.6L331.2 234C331.2 233.7 331.5 233.4 331.8 233.4H333.8C334.1 233.4 334.4 233.7 334.4 234L334.7 235.6C334.6 236 334.3 236.2 334 236.2Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.2 236.2H335.7C335.4 236.2 335.1 235.9 335.1 235.6L335.4 234C335.4 233.7 335.7 233.4 336 233.4H338C338.3 233.4 338.6 233.7 338.6 234L338.9 235.6C338.8 236 338.5 236.2 338.2 236.2Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.9 225H327.4C327.1 225 326.8 224.7 326.8 224.4L327.1 222.8C327.1 222.5 327.4 222.2 327.7 222.2H329.7C330 222.2 330.3 222.5 330.3 222.8L330.6 224.4C330.4 224.7 330.2 225 329.9 225Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 225H331.5C331.2 225 330.9 224.7 330.9 224.4L331.2 222.8C331.2 222.5 331.5 222.2 331.8 222.2H333.8C334.1 222.2 334.4 222.5 334.4 222.8L334.7 224.4C334.6 224.7 334.3 225 334 225Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.2 225H335.7C335.4 225 335.1 224.7 335.1 224.4L335.4 222.8C335.4 222.5 335.7 222.2 336 222.2H338C338.3 222.2 338.6 222.5 338.6 222.8L338.9 224.4C338.8 224.7 338.5 225 338.2 225Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.9 228.6H327.4C327.1 228.6 326.8 228.3 326.8 228L327.1 226.4C327.1 226.1 327.4 225.8 327.7 225.8H329.7C330 225.8 330.3 226.1 330.3 226.4L330.6 228C330.4 228.3 330.2 228.6 329.9 228.6Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 228.6H331.5C331.2 228.6 330.9 228.3 330.9 228L331.2 226.4C331.2 226.1 331.5 225.8 331.8 225.8H333.8C334.1 225.8 334.4 226.1 334.4 226.4L334.7 228C334.6 228.3 334.3 228.6 334 228.6Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.2 228.6H335.7C335.4 228.6 335.1 228.3 335.1 228L335.4 226.4C335.4 226.1 335.7 225.8 336 225.8H338C338.3 225.8 338.6 226.1 338.6 226.4L338.9 228C338.8 228.3 338.5 228.6 338.2 228.6Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.9 232.2H327.4C327.1 232.2 326.8 231.9 326.8 231.6L327.1 230C327.1 229.7 327.4 229.4 327.7 229.4H329.7C330 229.4 330.3 229.7 330.3 230L330.6 231.6C330.4 231.9 330.2 232.2 329.9 232.2Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 232.2H331.5C331.2 232.2 330.9 231.9 330.9 231.6L331.2 230C331.2 229.7 331.5 229.4 331.8 229.4H333.8C334.1 229.4 334.4 229.7 334.4 230L334.7 231.6C334.6 231.9 334.3 232.2 334 232.2Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.2 232.2H335.7C335.4 232.2 335.1 231.9 335.1 231.6L335.4 230C335.4 229.7 335.7 229.4 336 229.4H338C338.3 229.4 338.6 229.7 338.6 230L338.9 231.6C338.8 231.9 338.5 232.2 338.2 232.2Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.9 235.8H327.4C327.1 235.8 326.8 235.5 326.8 235.2L327.1 233.6C327.1 233.3 327.4 233 327.7 233H329.7C330 233 330.3 233.3 330.3 233.6L330.6 235.2C330.4 235.5 330.2 235.8 329.9 235.8Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 235.8H331.5C331.2 235.8 330.9 235.5 330.9 235.2L331.2 233.6C331.2 233.3 331.5 233 331.8 233H333.8C334.1 233 334.4 233.3 334.4 233.6L334.7 235.2C334.6 235.5 334.3 235.8 334 235.8Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.2 235.8H335.7C335.4 235.8 335.1 235.5 335.1 235.2L335.4 233.6C335.4 233.3 335.7 233 336 233H338C338.3 233 338.6 233.3 338.6 233.6L338.9 235.2C338.8 235.5 338.5 235.8 338.2 235.8Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.9 240H162.6C161.4 240 160.5 239 160.5 237.9V221.8C160.5 220.6 161.5 219.7 162.6 219.7H172.9C174.1 219.7 175 220.7 175 221.8V237.9C175 239 174.1 240 172.9 240Z",
    className: "illustration_tertiary"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.3 221.2C174.3 221.6 174.1 221.9 173.9 222.2C173.9 222.2 173.8 222.2 173.8 222.3C173.6 222.5 173.3 222.6 172.9 222.6H162.4C161.6 222.6 161 222 161 221.2C161 220.8 161.2 220.5 161.4 220.2C161.7 220 162 219.8 162.4 219.8H172.9C173 219.8 173.2 219.8 173.3 219.9C173.8 220 174.1 220.4 174.2 220.9C174.3 221 174.3 221.1 174.3 221.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.6 222.6H163.4L162.8 219.9L161.7 214.9L161.1 212.2C161 211.9 161.2 211.6 161.5 211.5H161.6C161.9 211.5 162.1 211.7 162.2 211.9L162.8 214.7L164 220L164.6 222.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.6 214.9L161.9 215.1C161.8 215.1 161.6 215 161.6 214.9L160.9 211.8C160.9 211.7 161 211.5 161.1 211.5L161.8 211.3C161.9 211.3 162.1 211.4 162.1 211.5L162.8 214.6C162.8 214.7 162.8 214.8 162.6 214.9Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.2 211.8L168.5 219.8L168.3 222.5H167.1L167.3 219.8L168 211.7C168 211.4 168.3 211.1 168.6 211.2C169 211.2 169.2 211.5 169.2 211.8Z",
    fill: "#D5598B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 211.9C177 212 177 212 177 212.1L174.3 220.9L173.9 222.3C173.7 222.5 173.4 222.6 173 222.6H172.6L173.4 219.9L175.9 211.7C176 211.4 176.3 211.2 176.6 211.3C176.8 211.4 177 211.7 177 211.9Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.2 214.6L172.5 219.8L172.1 222.5H169.6L170 219.8L170.7 214.3C170.8 213.8 171.2 213.5 171.7 213.6L172.4 213.7C172.9 213.7 173.2 214.2 173.2 214.6Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.2 248.8H233.3L235.5 233.7H253L255.2 248.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.2 248.8H207.3L214.4 233.7H232L229.2 248.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.8 248.8H280.8L273.7 233.7H256.1L258.8 248.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.6 316.4H-0.100098V216.4H94.4999C103.4 216.4 110.6 223.6 110.6 232.5V316.4Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.6 316.4H496.3V216.4H401.7C392.8 216.4 385.6 223.6 385.6 232.5V316.4Z",
    fill: "#FF7945"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_359_45708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpdesk);
export default __webpack_public_path__ + "static/media/Helpdesk.f5a702c5.svg";
export { ForwardRef as ReactComponent };